import { sendMonitoringEvent } from "./accessMonitoringActivity";

export const INACTIVITY_LIMIT = 60 * 60 * 1000;
export const LAST_ACTIVITY_KEY = "accountree-last-activity";
export const INACTIVITY_NOTICE_KEY = "accountree-inactivity-notice";
export const INACTIVITY_MESSAGE = "Sesioni ka përfunduar për shkak të pasivitetit. Kyçuni përsëri.";

let cleanup = null;
const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];

export function initializeSessionActivity() {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
  sessionStorage.removeItem(INACTIVITY_NOTICE_KEY);
}

function lastActivity() {
  const stored = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
  if (Number.isFinite(stored) && stored > 0 && stored <= Date.now()) return stored;
  // Existing sessions created before this feature get a timestamp once.
  const now = Date.now();
  localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
  return now;
}

// Called before React mounts: expired sessions must never render authenticated pages.
export function expireInactiveSession() {
  if (!localStorage.getItem("token")) return false;
  if (Date.now() - lastActivity() < INACTIVITY_LIMIT) return false;

  stopInactivityLogout();
  sendMonitoringEvent("logout");
  localStorage.clear();
  sessionStorage.setItem(INACTIVITY_NOTICE_KEY, INACTIVITY_MESSAGE);
  return true;
}

export function startInactivityLogout({ navigate = () => window.location.replace("/") } = {}) {
  stopInactivityLogout();
  if (!localStorage.getItem("token")) return;

  let timer = null;
  const checkSession = () => {
    clearTimeout(timer);
    if (!localStorage.getItem("token")) {
      stopInactivityLogout();
      return false;
    }
    if (expireInactiveSession()) {
      navigate();
      return false;
    }
    timer = setTimeout(checkSession, INACTIVITY_LIMIT - (Date.now() - lastActivity()));
    return true;
  };

  const recordActivity = () => {
    if (document.visibilityState !== "visible") return;
    if (!localStorage.getItem("token")) {
      stopInactivityLogout();
      return;
    }
    // Mouse/scroll events can arrive frequently. Limit storage broadcasts to once a second.
    if (Date.now() - lastActivity() < 1000) return;
    // A delayed event after sleep must not revive an already expired session.
    if (!checkSession()) return;
    localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
    checkSession();
  };
  const onStorage = (event) => {
    if (event.storageArea === localStorage &&
        (event.key === LAST_ACTIVITY_KEY || event.key === "token" || event.key === null)) {
      checkSession();
    }
  };
  const onVisibility = () => {
    if (document.visibilityState === "visible") checkSession();
  };

  events.forEach(event => window.addEventListener(event, recordActivity, { passive: true }));
  window.addEventListener("storage", onStorage);
  window.addEventListener("focus", checkSession);
  window.addEventListener("pageshow", checkSession);
  document.addEventListener("visibilitychange", onVisibility);
  cleanup = () => {
    clearTimeout(timer);
    events.forEach(event => window.removeEventListener(event, recordActivity));
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("focus", checkSession);
    window.removeEventListener("pageshow", checkSession);
    document.removeEventListener("visibilitychange", onVisibility);
  };
  checkSession();
  return stopInactivityLogout;
}

export function stopInactivityLogout() {
  if (cleanup) cleanup();
  cleanup = null;
}
